/* XGuidance Premium Home — assets/xg-home-premium.js v2 (no dependencies) */
(function () {
  'use strict';
  var mm = function (q) { return window.matchMedia ? window.matchMedia(q).matches : false; };
  var RM = mm('(prefers-reduced-motion: reduce)');
  var FINE = mm('(hover: hover) and (pointer: fine)');
  var SAVE = !!(navigator.connection && navigator.connection.saveData);
  var hasIO = 'IntersectionObserver' in window;
  var raf = window.requestAnimationFrame.bind(window);
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var clamp = function (v, a, b) { return v < a ? a : v > b ? b : v; };
  /* run fn once the page has loaded and the main thread is idle (keeps LCP/TBT clean) */
  var afterLoad = function (fn, delay) {
    var idle = window.requestIdleCallback || function (cb) { return setTimeout(cb, 1); };
    var go = function () { setTimeout(function () { idle(fn, { timeout: 2000 }); }, delay || 0); };
    if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
  };
  var GLYPHS = '!<>-_\\/[]{}=+*^?#XG018✦';

  function init(root) {
    if (!root || root.__xgh) return;
    var st = root.__xgh = { off: [] };
    var small = mm('(max-width: 749px)');
    root.classList.add('is-js');
    var on = function (el, ev, fn, opt) { el.addEventListener(ev, fn, opt); st.off.push(function () { el.removeEventListener(ev, fn, opt); }); };
    var fx = null;
    var getFx = function () { return fx; };

    /* ---------- lead text: split into words ---------- */
    $$('.xgh-words', root).forEach(function (el) {
      if (el.__split) return; el.__split = 1;
      var words = el.textContent.replace(/\s+/g, ' ').trim().split(' ');
      el.textContent = '';
      words.forEach(function (w, i) {
        var s = document.createElement('span');
        s.className = 'xgh-w'; s.style.setProperty('--wi', i); s.textContent = w;
        el.appendChild(s); el.appendChild(document.createTextNode(' '));
      });
    });

    /* ---------- animated headings: letters, gradients, 3D hover, particles ---------- */
    $$('[data-fxtext]', root).forEach(function (head) { textFx(head, on, getFx, st); });

    /* ---------- reveal + row visibility ---------- */
    var reveal = $$('.xgh-rv', root);
    $$('.xgh-bannerrow.is-hero .xgh-rv', root).forEach(function (el) { el.classList.add('is-in'); });
    if (hasIO && !RM) {
      var ioR = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); if (e.target.__onIn) e.target.__onIn(); ioR.unobserve(e.target); } });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      reveal.forEach(function (el) { if (!el.classList.contains('is-in')) ioR.observe(el); });
      var ioV = new IntersectionObserver(function (es) {
        es.forEach(function (e) { e.target.classList.toggle('is-vis', e.isIntersecting); });
      }, { rootMargin: '120px 0px 120px 0px' });
      $$('.xgh-row', root).forEach(function (r) { ioV.observe(r); });
      st.off.push(function () { ioR.disconnect(); ioV.disconnect(); });
    } else {
      reveal.forEach(function (el) { el.classList.add('is-in'); if (el.__onIn) el.__onIn(); });
      $$('.xgh-row', root).forEach(function (r) { r.classList.add('is-vis'); });
    }

    /* ---------- neon rings: rotating square only as big as the frame diagonal ---------- */
    var rings = $$('.xgh-frame__ring, .xgh-panel__ring', root);
    var sizeRing = function (r) { var b = r.getBoundingClientRect(); if (b.width) r.style.setProperty('--rs', Math.ceil(Math.sqrt(b.width * b.width + b.height * b.height) + 6) + 'px'); };
    rings.forEach(sizeRing);
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function (es) { es.forEach(function (e) { sizeRing(e.target); }); });
      rings.forEach(function (r) { ro.observe(r); }); st.off.push(function () { ro.disconnect(); });
    }

    /* ---------- videos: lazy, muted autoplay, auto aspect ratio ---------- */
    var vids = $$('video.xgh-video', root);
    vids.forEach(function (v) { v.muted = true; v.defaultMuted = true; v.setAttribute('muted', ''); });
    var loadVid = function (v) {
      if (v.__loaded || !v.dataset.src) return; v.__loaded = 1;
      v.addEventListener('loadedmetadata', function () {
        var fr = v.closest('[data-auto-ar]');
        if (fr && v.videoWidth && v.videoHeight) { var r = (v.videoWidth / v.videoHeight).toFixed(4); fr.style.setProperty('--ar', r); fr.style.setProperty('--arm', r); }
      }, { once: true });
      v.addEventListener('loadeddata', function () { v.classList.add('is-ready'); if (v.parentNode) v.parentNode.classList.add('is-loaded'); }, { once: true });
      v.addEventListener('error', function fb() {
        var full = v.dataset.srcFull;
        if (full && v.src.indexOf(full) < 0) { v.removeEventListener('error', fb); v.src = full; try { v.load(); } catch (e) {} }
      });
      v.src = (small && v.dataset.srcM) || v.dataset.src;
      v.preload = (RM || SAVE || small) ? 'metadata' : 'auto';
      try { v.load(); } catch (e) {}
    };
    var play = function (v) { if (RM || SAVE || v.closest('.xgh-slide')) return; var p = v.play(); if (p && p.catch) p.catch(function () {}); };
    if (hasIO) {
      var ioLoad = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { loadVid(e.target); ioLoad.unobserve(e.target); } });
      }, { rootMargin: small ? '200px 0px' : '700px 0px' });
      var ioPlay = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.target.closest('.xgh-slide')) return; if (e.isIntersecting) { loadVid(e.target); play(e.target); } else { e.target.pause(); } });
      }, { threshold: 0.15 });
      afterLoad(function () { vids.forEach(function (v) { if (!v.closest('.xgh-slide')) { ioLoad.observe(v); ioPlay.observe(v); } }); });
      st.off.push(function () { ioLoad.disconnect(); ioPlay.disconnect(); });
    } else { vids.forEach(function (v) { if (!v.closest('.xgh-slide')) { loadVid(v); play(v); } }); }

    /* ---------- components ---------- */
    $$('[data-slider]', root).forEach(function (el) { slider(el, st, on, loadVid); });
    $$('[data-carousel]', root).forEach(function (el) { carousel(el, st, on); });
    $$('[data-autoscroll]', root).forEach(function (el) { autoscroll(el, st, on); });
    $$('[data-panels]', root).forEach(function (el) { panels(el, on); });
    if (FINE && !RM) $$('[data-fs]', root).forEach(function (el) { floatScene(el, on); });

    /* ---------- 3D tilt on hover (every card, image and video) ---------- */
    if (FINE && !RM) {
      $$('.xgh-tilt', root).forEach(function (el) {
        if (el.classList.contains('xgh-hv--none')) return;
        var mag = el.classList.contains('xgh-hv--magnetic'), busy = 0, ev = null;
        var max = el.classList.contains('xgh-hv--pop') ? 9 : el.classList.contains('xgh-hv--float') ? 7 : el.classList.contains('xgh-hv--tilt') || el.classList.contains('xgh-pcard') ? 12 : 6;
        on(el, 'pointermove', function (e) {
          ev = e; if (busy) return; busy = 1;
          raf(function () {
            busy = 0; var r = el.getBoundingClientRect();
            var x = (ev.clientX - r.left) / r.width, y = (ev.clientY - r.top) / r.height;
            var m = r.width > 700 ? max * 0.55 : max;
            el.style.transition = 'transform .12s linear, translate .3s ease-out';
            el.style.transform = 'perspective(1100px) rotateX(' + ((0.5 - y) * m).toFixed(2) + 'deg) rotateY(' + ((x - 0.5) * m * 1.15).toFixed(2) + 'deg) translate3d(0,-6px,0)';
            if (mag) el.style.translate = ((x - 0.5) * 22).toFixed(1) + 'px ' + ((y - 0.5) * 16).toFixed(1) + 'px';
            el.style.setProperty('--gx', (x * 100).toFixed(1) + '%'); el.style.setProperty('--gy', (y * 100).toFixed(1) + '%');
          });
        });
        on(el, 'pointerleave', function () { el.style.transition = 'transform .9s cubic-bezier(.2,.8,.2,1), translate .9s cubic-bezier(.2,.8,.2,1)'; el.style.transform = ''; el.style.translate = ''; });
      });
    }

    /* ---------- scroll: chakra spine (across all sections), 3D on phones, particle kicks ---------- */
    var spine = root.querySelector('.xgh-spine');
    var s3d = (!FINE && !RM) ? $$('.xgh-s3d', root) : [];
    var lastY = window.scrollY, ticking = 0;
    function onScroll() {
      ticking = 0;
      var y = window.scrollY, dy = y - lastY; lastY = y;
      if (fx) fx.kick(dy);
      var vh = window.innerHeight, i;
      if (spine) {
        var all = document.querySelectorAll('[data-xgh]');
        var top = all[0].getBoundingClientRect().top, bot = all[all.length - 1].getBoundingClientRect().bottom;
        var p = clamp((vh * 0.6 - top) / Math.max(1, (bot - top) - vh * 0.4), 0, 1);
        spine.style.setProperty('--p', p.toFixed(3));
      }
      var rects = [];
      for (i = 0; i < s3d.length; i++) rects.push(s3d[i].getBoundingClientRect());
      for (i = 0; i < s3d.length; i++) {
        var b = rects[i];
        if (b.bottom < -50 || b.top > vh + 50) continue;
        var o = ((b.top + b.height / 2) - vh / 2) / vh;
        s3d[i].style.transform = 'perspective(900px) rotateX(' + (o * -14).toFixed(2) + 'deg) rotateY(' + (o * 4).toFixed(2) + 'deg) scale(' + (1 - Math.min(0.07, Math.abs(o) * 0.09)).toFixed(3) + ')';
      }
    }
    on(window, 'scroll', function () { if (!ticking) { ticking = 1; raf(onScroll); } }, { passive: true });
    onScroll();

    /* ---------- background energy field ---------- */
    var bg = root.querySelector('.xgh-bg');
    if (bg && !SAVE) afterLoad(function () { if (root.__xgh === st) fx = field(root, bg, small, st, on); }, small ? 1200 : 200);

    /* ---------- bass / music live mode ---------- */
    music(root, st, on, getFx);

    on(document, 'visibilitychange', function () { root.classList.toggle('is-hidden', document.hidden); if (fx) fx.toggle(!document.hidden); });
  }

  /* ================= animated text ================= */
  function textFx(head, on, getFx, st) {
    var entry = head.dataset.entry || 'wipe', idle = head.dataset.idle || 'flow';
    var hover3d = head.dataset.hover3d === 'true' && FINE && !RM;
    var needSplit = /rise|flip3d|typewriter|wave|scramble|split/.test(entry) || idle === 'wave' || hover3d || (entry !== 'wipe' && entry !== 'none' && entry !== 'blur' && entry !== 'zoom' && entry !== 'glitch');
    head.classList.add('xgh-fxe--' + entry);
    var chars = [];
    $$('[data-split]', head).forEach(function (t) {
      if (!needSplit || t.__split) return; t.__split = 1;
      var text = t.textContent; t.setAttribute('aria-label', text); t.textContent = '';
      var ci = 0;
      text.split(/(\s+)/).forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) { t.appendChild(document.createTextNode(' ')); return; }
        var w = document.createElement('span'); w.className = 'xgh-w'; w.setAttribute('aria-hidden', 'true');
        Array.prototype.forEach.call(part, function (ch) {
          var c = document.createElement('span'); c.className = 'xgh-c'; c.textContent = ch; c.style.setProperty('--ci', ci++);
          c.__ch = ch; w.appendChild(c); chars.push(c);
        });
        t.appendChild(w);
      });
      t.classList.add('is-split');
    });
    // keep the gradient continuous across letters
    var measure = function () {
      $$('.xgh-h__t.is-split', head).forEach(function (t) {
        var tb = t.getBoundingClientRect(); t.style.setProperty('--gw', Math.round(tb.width) + 'px');
        $$('.xgh-c', t).forEach(function (c) { c.style.setProperty('--cx', Math.round(c.getBoundingClientRect().left - tb.left) + 'px'); });
      });
    };
    if (chars.length) {
      measure();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
      var mt; on(window, 'resize', function () { clearTimeout(mt); mt = setTimeout(measure, 200); });
    }
    // scramble / decode entry
    if (entry === 'scramble' && chars.length && !RM) {
      chars.forEach(function (c) { c.textContent = c.__ch === ' ' ? ' ' : GLYPHS[(Math.random() * GLYPHS.length) | 0]; });
      head.__onIn = function () {
        var start = performance.now();
        (function tick(now) {
          var done = true;
          chars.forEach(function (c, i) {
            var t = start + 250 + i * 45;
            if (now >= t + 260) { c.textContent = c.__ch; }
            else { done = false; if (now >= t) c.textContent = GLYPHS[(Math.random() * GLYPHS.length) | 0]; }
          });
          if (!done) raf(tick); else measure();
        })(start);
      };
    }
    // letters react in 3D to the cursor
    if (hover3d && chars.length) {
      var busy = 0, ev = null, active = false;
      on(head, 'pointermove', function (e) {
        ev = e; active = true; if (busy) return; busy = 1;
        raf(function () {
          busy = 0; if (!active) return;
          chars.forEach(function (c) {
            var r = c.getBoundingClientRect(), cx = r.left + r.width / 2, cy = r.top + r.height / 2;
            var dx = (ev.clientX - cx) / 140, dy = (ev.clientY - cy) / 90, d = Math.sqrt(dx * dx + dy * dy), k = Math.max(0, 1 - d);
            c.classList.add('is-hot');
            c.style.transform = k > 0 ? 'perspective(420px) translate3d(0,' + (-k * 10).toFixed(1) + 'px,' + (k * 70).toFixed(1) + 'px) rotateX(' + (dy * -34 * k).toFixed(1) + 'deg) rotateY(' + (dx * 38 * k).toFixed(1) + 'deg)' : '';
          });
          var f = getFx(); if (f && Math.random() < 0.35) f.emit({ left: ev.clientX - 30, top: ev.clientY - 20, width: 60, height: 40, right: ev.clientX + 30, bottom: ev.clientY + 20 }, 1);
        });
      });
      on(head, 'pointerleave', function () { active = false; chars.forEach(function (c) { c.style.transform = ''; }); });
    }
    // energy particles rising from the text
    if (head.dataset.particles === 'true' && !RM) {
      var pt = setInterval(function () {
        var f = getFx(); if (!f || document.hidden) return;
        var r = head.getBoundingClientRect(); if (r.bottom < 0 || r.top > window.innerHeight) return;
        f.emit(r, 2);
      }, 180);
      st.off.push(function () { clearInterval(pt); });
    }
  }

  /* ================= slideshow: transitions, per-slide duration, video slides ================= */
  function slider(el, st, on, loadVid) {
    var slides = $$('.xgh-slide', el); if (!slides.length) return;
    var dots = $$('[data-dot]', el), bar = el.querySelector('.xgh-slider__bar');
    var n = slides.length, cur = 0, timer = 0, def = (parseFloat(el.dataset.autoplay) || 6) * 1000, vis = !hasIO, hover = false;
    var auto = el.dataset.auto !== 'false';
    var warm = function (k) { var s = slides[(k + n) % n], im = s.querySelector('img'), v = s.querySelector('video'); if (im && im.loading === 'lazy') im.loading = 'eager'; if (v) loadVid(v); };
    var vidOf = function (k) { return slides[k].querySelector('video'); };
    function durOf(k, cb) {
      var d = parseFloat(slides[k].dataset.dur);
      if (d > 0) return cb(d * 1000);
      var v = vidOf(k);
      if (v) { if (v.duration && isFinite(v.duration)) return cb(v.duration * 1000); v.addEventListener('loadedmetadata', function () { cb(isFinite(v.duration) ? v.duration * 1000 : def); }, { once: true }); setTimeout(function () { if (!(v.duration > 0)) cb(def); }, 2500); return; }
      cb(def);
    }
    var token = 0;
    function restart() {
      clearTimeout(timer); token++;
      var my = token;
      var v = vidOf(cur);
      $$('video', el).forEach(function (x, i) { if (x !== v) x.pause(); });
      if (v) { loadVid(v); if (vis && !RM && !SAVE) { try { v.currentTime = 0; } catch (e) {} var p = v.play(); if (p && p.catch) p.catch(function () {}); } }
      if (bar) { bar.classList.remove('is-run'); void bar.offsetWidth; }
      if (!vis || hover || RM || !auto || n < 2) return;
      durOf(cur, function (ms) {
        if (my !== token) return;
        if (bar) { bar.style.setProperty('--dur', ms + 'ms'); bar.classList.add('is-run'); }
        timer = setTimeout(function () { go(cur + 1, 'next'); }, ms);
      });
    }
    function go(i, dir) {
      i = (i + n) % n;
      if (i !== cur) {
        el.setAttribute('data-dir', dir || (i > cur ? 'next' : 'prev'));
        slides.forEach(function (s) { s.classList.remove('is-leaving'); });
        slides[cur].classList.remove('is-active'); slides[cur].classList.add('is-leaving');
        var old = slides[cur]; setTimeout(function () { old.classList.remove('is-leaving'); }, 1250);
        slides[i].classList.add('is-active');
        if (dots[cur]) { dots[cur].classList.remove('is-active'); dots[cur].removeAttribute('aria-current'); }
        if (dots[i]) { dots[i].classList.add('is-active'); dots[i].setAttribute('aria-current', 'true'); }
        cur = i;
      }
      warm(i + 1);
      restart();
    }
    el.__xghGo = function (i) { go(i); };
    var prev = el.querySelector('[data-prev]'), next = el.querySelector('[data-next]');
    if (prev) on(prev, 'click', function () { go(cur - 1, 'prev'); });
    if (next) on(next, 'click', function () { go(cur + 1, 'next'); });
    dots.forEach(function (d, i) { on(d, 'click', function () { go(i); }); });
    if (FINE) { on(el, 'mouseenter', function () { hover = true; clearTimeout(timer); token++; if (bar) bar.classList.remove('is-run'); }); on(el, 'mouseleave', function () { hover = false; restart(); }); }
    var sx = 0, sy = 0, moved = false;
    on(el, 'touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; moved = false; }, { passive: true });
    on(el, 'touchend', function (e) {
      var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { moved = true; go(cur + (dx < 0 ? 1 : -1), dx < 0 ? 'next' : 'prev'); }
    }, { passive: true });
    on(el, 'click', function (e) { if (moved) { e.preventDefault(); moved = false; } }, true);
    if (hasIO) {
      var io = new IntersectionObserver(function (es) { vis = es[0].isIntersecting; if (vis) { warm(cur); warm(cur + 1); restart(); } else { clearTimeout(timer); token++; var v = vidOf(cur); if (v) v.pause(); } }, { threshold: 0.25 });
      io.observe(el); st.off.push(function () { io.disconnect(); });
    }
    st.off.push(function () { clearTimeout(timer); });
    restart();
  }

  /* ================= auto-scrolling rows (3D navigation, reviews) ================= */
  function autoscroll(vp, st, on) {
    var speed = parseFloat(vp.dataset.autoscroll) || 0;
    var clone = vp.querySelector('[data-clone]');
    var panel = vp.closest('.xgh-nav3d__panel');
    var prev = panel && panel.querySelector('[data-nprev]'), next = panel && panel.querySelector('[data-nnext]');
    var paused = false, resumeT = 0, last = 0, vis = !hasIO, pos = 0, running = false;
    /* loop width is cached: reading offsetLeft every frame right after writing scrollLeft forced a layout per frame (mobile lag) */
    var halfC = 0;
    var half = function () { if (!halfC) halfC = clone ? clone.offsetLeft : vp.scrollWidth / 2; return halfC; };
    var resetHalf = function () { halfC = 0; };
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(resetHalf); ro.observe(vp); if (clone) ro.observe(clone);
      st.off.push(function () { ro.disconnect(); });
    } else on(window, 'resize', resetHalf);
    on(vp, 'load', resetHalf, true);
    var hold = function (ms) { paused = true; clearTimeout(resumeT); resumeT = setTimeout(function () { paused = false; pos = vp.scrollLeft; }, ms || 2500); };
    function tick(ts) {
      if (!running) return;
      raf(tick);
      var dt = last ? Math.min(50, ts - last) : 16; last = ts;
      if (paused || !vis || !speed || RM) return;
      pos += speed * dt / 1000;
      var h = half();
      if (h > 0 && pos >= h) pos -= h;
      vp.scrollLeft = pos;
    }
    var start = function () { if (running) return; running = true; last = 0; pos = vp.scrollLeft; raf(tick); };
    var stop = function () { running = false; };
    on(vp, 'pointerenter', function (e) { if (e.pointerType === 'mouse') { paused = true; clearTimeout(resumeT); } });
    on(vp, 'pointerleave', function (e) { if (e.pointerType === 'mouse') hold(600); });
    on(vp, 'touchstart', function () { hold(3000); }, { passive: true });
    on(vp, 'wheel', function () { hold(2500); }, { passive: true });
    on(vp, 'focusin', function () { paused = true; });
    on(vp, 'focusout', function () { hold(1500); });
    on(vp, 'scroll', function () {
      if (!paused) return;
      var h = half(); if (h > 0 && vp.scrollLeft >= h) vp.scrollLeft -= h;
    }, { passive: true });
    var step = function (d) { hold(3500); var item = vp.querySelector('li, figure'); var w = item ? item.getBoundingClientRect().width * 2 : vp.clientWidth * 0.6; vp.scrollBy({ left: d * w, behavior: 'smooth' }); };
    if (prev) on(prev, 'click', function () { if (vp.scrollLeft < 10) vp.scrollLeft += half(); step(-1); });
    if (next) on(next, 'click', function () { step(1); });
    if (FINE) {
      var down = false, x0 = 0, s0 = 0, drag = false;
      on(vp, 'pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.button !== 0) return; down = true; drag = false; x0 = e.clientX; s0 = vp.scrollLeft; });
      on(window, 'pointermove', function (e) { if (!down) return; var dx = e.clientX - x0; if (!drag && Math.abs(dx) > 6) { drag = true; vp.classList.add('is-drag'); paused = true; } if (drag) vp.scrollLeft = s0 - dx; });
      on(window, 'pointerup', function () { if (!down) return; down = false; if (drag) { vp.classList.remove('is-drag'); hold(1500); setTimeout(function () { drag = false; }, 0); } });
      on(vp, 'click', function (e) { if (drag) { e.preventDefault(); e.stopPropagation(); } }, true);
      on(vp, 'dragstart', function (e) { e.preventDefault(); });
    }
    if (hasIO) {
      var io = new IntersectionObserver(function (es) { vis = es[0].isIntersecting; if (vis) start(); else stop(); });
      io.observe(vp); st.off.push(function () { io.disconnect(); });
    } else start();
    st.off.push(stop, function () { clearTimeout(resumeT); });
  }

  /* ================= products: carousel / 3D ring / coverflow ================= */
  function carousel(el, st, on) {
    var t = el.querySelector('[data-ctrack]'); if (!t) return;
    var lay = el.dataset.layout || 'carousel';
    var p = el.querySelector('[data-cprev]'), n = el.querySelector('[data-cnext]');
    if (lay === 'ring') return ring(el, t, p, n, st, on);
    var step = function (d) { t.scrollBy({ left: d * t.clientWidth * 0.8, behavior: RM ? 'auto' : 'smooth' }); };
    var cells = $$('.xgh-pcell', t);
    var upd = function () {
      var max = t.scrollWidth - t.clientWidth - 4;
      if (p) { p.disabled = t.scrollLeft <= 4; p.style.opacity = p.disabled ? '.35' : ''; }
      if (n) { n.disabled = t.scrollLeft >= max; n.style.opacity = n.disabled ? '.35' : ''; }
      if (lay === 'coverflow') {
        var tb = t.getBoundingClientRect(), mid = tb.left + tb.width / 2;
        cells.forEach(function (c) {
          var r = c.getBoundingClientRect(), f = clamp(((r.left + r.width / 2) - mid) / (tb.width / 2), -1, 1);
          c.style.setProperty('--cf', f.toFixed(3)); c.style.setProperty('--cfa', Math.abs(f).toFixed(3));
        });
      }
    };
    if (p) on(p, 'click', function () { step(-1); });
    if (n) on(n, 'click', function () { step(1); });
    var tk = 0; on(t, 'scroll', function () { if (!tk) { tk = 1; raf(function () { tk = 0; upd(); }); } }, { passive: true });
    on(window, 'resize', upd);
    upd();
    if (!FINE || lay === 'grid') return;
    var down = false, x0 = 0, s0 = 0, drag = false;
    on(t, 'pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.button !== 0) return; down = true; drag = false; x0 = e.clientX; s0 = t.scrollLeft; });
    on(window, 'pointermove', function (e) {
      if (!down) return; var dx = e.clientX - x0;
      if (!drag && Math.abs(dx) > 6) { drag = true; t.classList.add('is-drag'); }
      if (drag) t.scrollLeft = s0 - dx;
    });
    on(window, 'pointerup', function () { if (!down) return; down = false; if (drag) { t.classList.remove('is-drag'); setTimeout(function () { drag = false; }, 0); } });
    on(t, 'click', function (e) { if (drag) { e.preventDefault(); e.stopPropagation(); } }, true);
    on(t, 'dragstart', function (e) { e.preventDefault(); });
  }
  function ring(el, t, p, n, st, on) {
    var cells = $$('.xgh-pcell', t), N = cells.length || 1, a = 0, target = 0, vis = !hasIO, running = false, hold = 0, last = 0;
    var size = function () {
      var cw = Math.min(280, Math.max(190, el.clientWidth * (el.clientWidth < 750 ? 0.56 : 0.22)));
      var rz = Math.round((cw / 2 + 14) / Math.tan(Math.PI / Math.max(3, N)));
      el.style.setProperty('--cw', cw + 'px'); t.style.setProperty('--cw', cw + 'px'); t.style.setProperty('--rz', rz + 'px');
      var card = cells[0] && cells[0].firstElementChild; if (card) t.style.setProperty('--ringh', (card.offsetHeight + 60) + 'px');
    };
    size(); on(window, 'resize', size);
    var step = 360 / N;
    if (p) on(p, 'click', function () { hold = 4000; target += step; });
    if (n) on(n, 'click', function () { hold = 4000; target -= step; });
    function tick(ts) {
      if (!running) return; raf(tick);
      var dt = last ? Math.min(50, ts - last) : 16; last = ts;
      if (hold > 0) hold -= dt; else if (!RM) target -= dt * 0.006;
      a += (target - a) * 0.08;
      t.style.setProperty('--ra', a.toFixed(2) + 'deg');
    }
    var down = false, x0 = 0, t0 = 0;
    on(t, 'pointerdown', function (e) { down = true; x0 = e.clientX; t0 = target; hold = 1e9; });
    on(window, 'pointermove', function (e) { if (down) target = t0 + (e.clientX - x0) * 0.35; });
    on(window, 'pointerup', function () { if (down) { down = false; hold = 2500; } });
    var start = function () { if (running) return; running = true; last = 0; raf(tick); };
    if (hasIO) { var io = new IntersectionObserver(function (es) { vis = es[0].isIntersecting; if (vis) start(); else running = false; }); io.observe(el); st.off.push(function () { io.disconnect(); }); } else start();
    st.off.push(function () { running = false; });
  }

  /* ================= expanding panels ================= */
  function panels(wrap, on) {
    var ps = $$('[data-panel]', wrap);
    var open = function (p) { ps.forEach(function (x) { x.classList.toggle('is-open', x === p); }); };
    ps.forEach(function (p) {
      if (FINE) on(p, 'mouseenter', function () { open(p); });
      on(p, 'focus', function () { open(p); });
      on(p, 'click', function (e) { if (!p.classList.contains('is-open')) { e.preventDefault(); open(p); } });
    });
  }

  /* ================= floating scene: depth parallax ================= */
  function floatScene(el, on) {
    var items = $$('[data-depth]', el), busy = 0, ev = null;
    on(el, 'pointermove', function (e) {
      ev = e; if (busy) return; busy = 1;
      raf(function () {
        busy = 0; var r = el.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width - 0.5, y = (ev.clientY - r.top) / r.height - 0.5;
        items.forEach(function (it) { var d = parseFloat(it.dataset.depth) || 0; it.style.transform = 'translate3d(' + (x * d).toFixed(1) + 'px,' + (y * d).toFixed(1) + 'px,0)'; });
      });
    });
    on(el, 'pointerleave', function () { items.forEach(function (it) { it.style.transform = ''; }); });
  }

  /* ================= neurons + energy particles canvas ================= */
  function field(root, host, small, st, on) {
    var cv = document.createElement('canvas'); cv.setAttribute('aria-hidden', 'true');
    host.insertBefore(cv, host.querySelector('.xgh-bg__shade'));
    var ctx = cv.getContext('2d', { alpha: true }); if (!ctx) return null;
    var level = root.dataset.fx || 'full';
    var neurons = root.dataset.neurons !== 'false';
    var cursor = root.dataset.cursor !== 'false' && FINE;
    var mult = (level === 'lite' ? 0.4 : level === 'balanced' ? 0.7 : 1) * (small ? 0.5 : 1);
    var W = 0, H = 0, DPR = 1, N = 0, D = small ? 92 : 118, nodes = [], sparks = [], pulses = [], stars = [];
    var COLORS = [[240, 199, 94], [21, 242, 252], [187, 48, 254], [0, 255, 136], [255, 241, 184]];
    var sprites = COLORS.map(function (c) {
      var s = document.createElement('canvas'); s.width = s.height = 48; var g = s.getContext('2d');
      var gr = g.createRadialGradient(24, 24, 0, 24, 24, 24);
      gr.addColorStop(0, 'rgba(255,255,255,1)'); gr.addColorStop(0.18, 'rgba(' + c + ',.95)');
      gr.addColorStop(0.45, 'rgba(' + c + ',.28)'); gr.addColorStop(1, 'rgba(' + c + ',0)');
      g.fillStyle = gr; g.fillRect(0, 0, 48, 48); return s;
    });
    var ptr = { x: -9999, y: -9999, on: false }, kickAmt = 0, beatAmp = 0, running = false, visible = !hasIO, frame = 0, slowFrames = 0, last = 0;

    function size() {
      DPR = Math.min(window.devicePixelRatio || 1, small ? 1 : 1.25);
      W = window.innerWidth; H = window.innerHeight;
      cv.width = Math.round(W * DPR); cv.height = Math.round(H * DPR);
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
      var target = Math.round(Math.min(small ? 46 : 120, Math.max(small ? 22 : 40, (W * H) / 13000)) * mult);
      while (nodes.length < target) nodes.push(mk());
      if (nodes.length > target) nodes.length = target;
      N = nodes.length;
      var sc = Math.round(Math.min(small ? 70 : 170, (W * H) / (small ? 5200 : 7600)) * (level === 'lite' ? 0.6 : 1));
      stars.length = 0;
      for (var k = 0; k < sc; k++) stars.push({ x: Math.random() * W, y: Math.random() * H, s: Math.random() < 0.15 ? 2 : 1, p: Math.random() * 6.28, v: 0.01 + Math.random() * 0.035, z: 0.05 + Math.random() * 0.12, c: Math.random() < 0.25 ? '255,236,170' : Math.random() < 0.3 ? '160,245,255' : '255,255,255' });
    }
    function mk() {
      var z = 0.35 + Math.random() * 0.65;
      return { x: Math.random() * W, y: Math.random() * H, z: z, vx: (Math.random() - 0.5) * 0.18, vy: (Math.random() - 0.5) * 0.14 - 0.05,
        c: (Math.random() * 5) | 0, ph: Math.random() * 6.28, sx: 0, sy: 0 };
    }
    function spark(x, y, vx, vy, life, c, sz) {
      if (sparks.length > (small ? 70 : 170)) return;
      sparks.push({ x: x, y: y, vx: vx, vy: vy, l: life, m: life, c: c, s: sz });
    }
    function draw(ts) {
      if (!running) return;
      raf(draw);
      if (small && last && ts - last < 28) return; // phones: ~30 fps ambient field, saves battery
      var dt = last ? ts - last : 16; last = ts;
      if (small) dt /= 2;
      if (dt > 30) { if (++slowFrames > 90 && N > 16) { nodes.length = N = Math.round(N * 0.7); slowFrames = 0; } } else if (slowFrames > 0) slowFrames--;
      frame++;
      var sy = window.scrollY, i, j, n, m;
      ctx.clearRect(0, 0, W, H);
      beatAmp *= 0.9;
      // twinkling star field (drifts up slowly, parallax with scroll)
      for (i = 0; i < stars.length; i++) {
        var so = stars[i]; so.p += so.v; so.y -= so.z * 0.35;
        var syy = (so.y - sy * so.z) % H; if (syy < 0) syy += H;
        ctx.fillStyle = 'rgba(' + so.c + ',' + (0.35 + 0.55 * Math.abs(Math.sin(so.p))).toFixed(2) + ')';
        ctx.fillRect(so.x, syy, so.s, so.s);
      }
      // node positions (parallax with scroll by depth)
      for (i = 0; i < N; i++) {
        n = nodes[i];
        n.x += n.vx; n.y += n.vy; n.ph += 0.03;
        if (cursor && ptr.on) { var ddx = ptr.x - n.sx, ddy = ptr.y - n.sy, d2 = ddx * ddx + ddy * ddy; if (d2 < 40000) { n.vx += ddx * 0.000025; n.vy += ddy * 0.000025; } }
        n.vx *= 0.995; n.vy *= 0.995;
        if (Math.abs(n.vx) < 0.03) n.vx += (Math.random() - 0.5) * 0.02;
        if (n.x < -20) n.x = W + 20; else if (n.x > W + 20) n.x = -20;
        var yy = (n.y - sy * n.z * 0.22) % (H + 40); if (yy < -20) yy += H + 40;
        n.sx = n.x; n.sy = yy - 20;
      }
      // synapses
      if (neurons) {
        ctx.lineWidth = 0.8;
        for (i = 0; i < N; i++) {
          n = nodes[i];
          for (j = i + 1; j < N; j++) {
            m = nodes[j];
            var dx = n.sx - m.sx; if (dx > D || dx < -D) continue;
            var dy = n.sy - m.sy; if (dy > D || dy < -D) continue;
            var dd = Math.sqrt(dx * dx + dy * dy); if (dd > D) continue;
            var a = (1 - dd / D) * (0.3 + beatAmp * 0.4);
            ctx.strokeStyle = 'rgba(190,225,255,' + a.toFixed(3) + ')';
            ctx.beginPath(); ctx.moveTo(n.sx, n.sy); ctx.lineTo(m.sx, m.sy); ctx.stroke();
            if (pulses.length < (small ? 6 : 16) && Math.random() < 0.0009) pulses.push({ a: i, b: j, t: 0, c: (Math.random() * 5) | 0 });
          }
          if (cursor && ptr.on) {
            var px = n.sx - ptr.x, py = n.sy - ptr.y, pd = Math.sqrt(px * px + py * py);
            if (pd < 170) { ctx.strokeStyle = 'rgba(255,225,150,' + ((1 - pd / 170) * 0.45).toFixed(3) + ')'; ctx.beginPath(); ctx.moveTo(n.sx, n.sy); ctx.lineTo(ptr.x, ptr.y); ctx.stroke(); }
          }
        }
        // signals travelling along synapses
        for (i = pulses.length - 1; i >= 0; i--) {
          var p = pulses[i]; p.t += 0.022;
          var A = nodes[p.a], B = nodes[p.b];
          if (!A || !B || p.t >= 1) { pulses.splice(i, 1); continue; }
          var qx = A.sx + (B.sx - A.sx) * p.t, qy = A.sy + (B.sy - A.sy) * p.t;
          ctx.drawImage(sprites[p.c], qx - 9, qy - 9, 18, 18);
        }
      }
      // neurons (glowing nodes)
      ctx.globalCompositeOperation = 'lighter';
      for (i = 0; i < N; i++) {
        n = nodes[i];
        var r = (3 + n.z * 7) * (1 + beatAmp * 0.6) * (0.85 + 0.15 * Math.sin(n.ph));
        ctx.globalAlpha = 0.45 + n.z * 0.45;
        ctx.drawImage(sprites[n.c], n.sx - r, n.sy - r, r * 2, r * 2);
      }
      // energy sparks (scroll, cursor, beat)
      if (kickAmt > 1) {
        var k = Math.min(small ? 2 : 4, kickAmt / 30);
        for (i = 0; i < k; i++) spark(Math.random() * W, H + 10, (Math.random() - 0.5) * 0.6, -(1.5 + Math.random() * 2.6), 90 + Math.random() * 60, (Math.random() * 5) | 0, 6 + Math.random() * 8);
        kickAmt *= 0.82;
      }
      for (i = sparks.length - 1; i >= 0; i--) {
        var s = sparks[i]; s.x += s.vx; s.y += s.vy; s.vy -= 0.006; s.vx *= 0.99; s.l--;
        if (s.l <= 0) { sparks.splice(i, 1); continue; }
        var life = s.l / s.m; ctx.globalAlpha = life;
        var sz = s.s * (0.6 + life * 0.6);
        ctx.drawImage(sprites[s.c], s.x - sz / 2, s.y - sz / 2, sz, sz);
      }
      ctx.globalAlpha = 1; ctx.globalCompositeOperation = 'source-over';
    }
    function start() { if (running || RM) return; running = true; last = 0; raf(draw); }
    function stop() { running = false; }
    size();
    if (RM) { running = true; draw(0); running = false; }
    var rt; on(window, 'resize', function () { clearTimeout(rt); rt = setTimeout(function () { size(); if (RM) { running = true; draw(0); running = false; } }, 180); });
    if (cursor) {
      var lx = 0, ly = 0;
      on(window, 'pointermove', function (e) {
        ptr.x = e.clientX; ptr.y = e.clientY; ptr.on = true;
        var dx = e.clientX - lx, dy = e.clientY - ly;
        if (dx * dx + dy * dy > 260 && running) { lx = e.clientX; ly = e.clientY; spark(e.clientX, e.clientY, (Math.random() - 0.5) * 1.2, -0.6 - Math.random(), 50, (Math.random() * 5) | 0, 8 + Math.random() * 8); }
      }, { passive: true });
      on(document, 'pointerleave', function () { ptr.on = false; });
    }
    if (hasIO) {
      var io = new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible && !document.hidden) start(); else stop(); });
      io.observe(root); st.off.push(function () { io.disconnect(); });
    } else start();
    st.off.push(stop, function () { cv.remove(); });
    return {
      emit: function (r, n) {
        if (!running) return;
        for (var i = 0; i < n; i++) {
          var edge = Math.random();
          var x = r.left + Math.random() * r.width, y = edge < 0.5 ? r.top + Math.random() * r.height * 0.3 : r.bottom - Math.random() * r.height * 0.3;
          spark(x, y, (Math.random() - 0.5) * 0.8, -(0.3 + Math.random() * 1.1), 60 + Math.random() * 50, (Math.random() * 5) | 0, 5 + Math.random() * 9);
        }
      },
      kick: function (dy) { kickAmt += Math.min(80, Math.abs(dy)); },
      beat: function () {
        beatAmp = 1;
        if (!running || !N) return;
        var o = nodes[(Math.random() * N) | 0];
        for (var i = 0; i < (small ? 5 : 10); i++) { var a = Math.random() * 6.283, v = 1 + Math.random() * 2; spark(o.sx, o.sy, Math.cos(a) * v, Math.sin(a) * v - 0.4, 45 + Math.random() * 25, (Math.random() * 5) | 0, 7 + Math.random() * 7); }
      },
      toggle: function (b) { if (b && visible) start(); else stop(); }
    };
  }

  /* ================= bass: XG Mix live mode ================= */
  function music(root, st, on, getFx) {
    var orb = root.querySelector('[data-orb]');
    var audio = document.getElementById('xg-audio');
    if (!audio && root.dataset.music) { audio = new Audio(root.dataset.music); audio.preload = 'none'; audio.volume = 0.6; }
    if (!audio) { if (orb) orb.hidden = true; return; }
    var bpm = parseFloat(root.dataset.bpm) || 124, timer = 0;
    var footerBtn = document.getElementById('xg-music-btn');
    function setLive(live) {
      root.classList.toggle('xgh--live', live);
      if (orb) orb.setAttribute('aria-pressed', live ? 'true' : 'false');
      if (footerBtn) { footerBtn.classList.toggle('is-playing', live); footerBtn.setAttribute('aria-pressed', live ? 'true' : 'false'); footerBtn.title = live ? 'Pause' : 'Play'; }
      clearInterval(timer);
      if (live && !RM) timer = setInterval(function () { var f = getFx(); if (f) f.beat(); }, 60000 / bpm);
    }
    on(audio, 'play', function () { setLive(true); });
    on(audio, 'pause', function () { setLive(false); });
    on(audio, 'ended', function () { setLive(false); });
    if (orb) on(orb, 'click', function () {
      if (audio.paused) { var p = audio.play(); if (p && p.catch) p.catch(function () { setLive(false); }); } else audio.pause();
    });
    if (!audio.paused) setLive(true);
    st.off.push(function () { clearInterval(timer); });
  }

  function destroy(root) {
    if (!root || !root.__xgh) return;
    root.__xgh.off.forEach(function (f) { try { f(); } catch (e) {} });
    root.__xgh = null; root.classList.remove('is-js', 'xgh--live');
  }

  function boot() { $$('[data-xgh]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  /* theme editor support */
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-xgh]')); });
  document.addEventListener('shopify:section:unload', function (e) { destroy(e.target.querySelector('[data-xgh]')); });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target; if (!el || !el.closest) return;
    var slide = el.closest('.xgh-slide');
    if (slide) { var sl = slide.closest('[data-slider]'); if (sl && sl.__xghGo) sl.__xghGo(parseInt(slide.dataset.slide, 10) || 0); }
    var rv = el.closest('.xgh-rv') || el.querySelector('.xgh-rv'); if (rv) rv.classList.add('is-in');
    var pn = el.closest('[data-panel]'); if (pn) pn.dispatchEvent(new Event('focus'));
  });
})();
